// extracted by mini-css-extract-plugin
export default {"title":"SetionTitle_title__iB1xb","headerLine":"SetionTitle_headerLine__64WaP"};